import styled from 'styled-components';
import { ifProp } from 'styled-tools';
import theme from './Chrome.theme';

export const Chrome = styled('div')``;

export const Page = styled('div')`
  background-color: ${props => theme(props).pageBgColor};
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  position: relative;
`;

export const Overlay = styled('div')`
  background: rgba(17, 17, 17, 0.57);
  display: ${ifProp('isVisible', 'block', 'none')};
  height: 100%;
  left: 0;
  position: absolute;
  width: 100vw;
  z-index: 10;
`;

export const Notifications = styled('div')`
  max-height: 100vh;
  overflow: auto;
  position: fixed;
  right: 0;
  top: 0;
  width: 100%;
  z-index: 11;
`;

export const Main = styled('div')`
  background-color: ${props => theme(props).contentBgColor};
  display: flex;
  flex: 1;
  flex-direction: column;
  height: 100%;
  padding: ${props => theme(props).contentPadding};
  position: relative;
`;
